import React from "react";

function Colors_2021() {
  return (
    <div>
      <h1>Colors_2021 Component</h1>
      <p>This is the Colors 2021 tutorial page content.</p>
    </div>
  );
}

export default Colors_2021;
